<template>
  <div class="container p-4">
    <div v-if="loadingData">
      <div class="loader">
        <div class="loader-icon"></div>
      </div>
    </div>
    <card v-show="!loadingData">
      <div class="row">
        <div class="col-md-8"></div>

        <div class="col-md-9">
          <h4 slot="header" class="card-title">{{ window_title }}</h4>
          <p class="text-muted text-sm mt-n2">
            Te invitamos a completar tu perfil y llenar todos tus datos para mantener tu información actualizada.
          </p>
        </div>
      </div>

      <form role="form" class="px-3">
        <div class="row">
          <div class="col-md-12 text-center">
            <label>Imagen de perfil</label>
            <br />
            <div
              v-if="
                form_update.url_image &&
                typeof form_update.url_image === 'string'
              "
              class="position-relative"
              style="max-width: 200px; display: inline-block"
            >
              <img
                class="img-fluid mb-1"
                :src="form_update.url_image"
                style="max-height: 200px; max-width: 200px; display: block"
              />
              <button
                class="btn bg-gradient-fvf btn-sm position-absolute"
                style="
                  top: -10px;
                  right: -10px;
                  width: 30px;
                  height: 30px;
                  border-radius: 50%;
                  padding: 0;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                "
                @click="removeProfileImage"
              >
                X
              </button>
            </div>
            <div
              v-else
              style="position: relative; max-width: 200px; margin: 0 auto"
            >
              <file-pond
                ref="filePond"
                accepted-file-types="image/jpeg, image/png"
                name="image"
                v-model="form_update.url_image"
                label-idle="Subir imagen"
                :credits="false"
                @updatefiles="handleFileUpdate"
                @removefile="handleFileUpdate"
                style="width: 200px"
              ></file-pond>
              <img
                id="backgroundImage"
                src="../../../public/img/load_img.jpg"
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  pointer-events: none;
                  opacity: 0.5;
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                "
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <base-input
              type="text"
              label="Nombres"
              placeholder="Indica tus nombres"
              v-model="form_update.first_name"
            >
            </base-input>
          </div>
          <div class="col-md-6">
            <base-input
              type="text"
              label="Apellidos"
              placeholder="Indica tus apellidos"
              v-model="form_update.last_name"
            >
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <base-input
              type="text"
              label="Cédula de identidad / Pasaporte"
              placeholder="Indica tu cédula o pasaporte"
              v-model="form_update.dni"
            >
            </base-input>
          </div>
          <div class="col-md-6">
            <label>Correo</label>
            <div class="d-flex align-items-center">
              <input type="email" class="form-control" :value="form_update.email" disabled style="background-color: #f4f4f4; opacity: 0.85;" />
              <button type="button" class="btn btn-sm bg-gradient-fvf ms-2" style="white-space: nowrap; border-radius: 8px; height: 38px; font-size: 0.8rem;" @click="openEmailChangeModal">
                Cambiar correo
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <base-input
              type="number"
              label="Teléfono"
              placeholder="Indica tu teléfono"
              v-model="form_update.phone"
            >
            </base-input>
          </div>
          <!-- <div class="col-md-6">
            <label>Tipo de usuario</label>
            <multiselect
              v-model="form_update.id_type_user"
              label="name"
              :options="TypeUserTmp"
              selectLabel="Click/enter para elegir"
              selectedLabel="Seleccionado"
              deselectLabel="Click/Enter para remover"
              select-label="Seleccionar"
              placeholder="Seleccione"
              style="border-radius: 30px !important; text-transform: none"
            >
            </multiselect>
          </div> -->
        </div>
        <div class="row">
          <div class="col-md-6">
            <label>País</label>
            <multiselect
              v-model="form_update.country"
              label="name"
              :options="sortedCountryTmp"
              selectLabel="Click/enter para elegir"
              selectedLabel="Seleccionado"
              deselectLabel="Click/Enter para remover"
              select-label="Seleccionar"
              placeholder="Seleccione"
              @input="onCountryChange"
              @select="onCountryChange"
              style="border-radius: 30px !important; text-transform: capitalize"
            >
            </multiselect>
          </div>
          <div class="col-md-6">
            <label>Estado</label>
            <multiselect
              v-model="form_update.state"
              label="name"
              :options="StateTmp"
              selectLabel="Click/enter para elegir"
              selectedLabel="Seleccionado"
              deselectLabel="Click/Enter para remover"
              select-label="Seleccionar"
              placeholder="Seleccione"
              @input="onStateChange"
              @select="onStateChange"
              style="border-radius: 30px !important; text-transform: capitalize"
              :disabled="!form_update.country"
            >
            </multiselect>
            <p
              v-if="!form_update.country"
              style="
                color: rgb(184, 49, 49);
                text-transform: none !important;
                font-size: 11px;
              "
            >
              Debe seleccionar un Pais para seleccionar un Estado
            </p>
          </div>
          <div class="col-md-6">
            <label>Ciudad</label>
            <multiselect
              v-model="form_update.id_city"
              label="name"
              :options="CityTmp"
              selectLabel="Click/enter para elegir"
              selectedLabel="Seleccionado"
              deselectLabel="Click/Enter para remover"
              select-label="Seleccionar"
              placeholder="Seleccione"
              style="border-radius: 30px !important; text-transform: capitalize"
              :disabled="!form_update.state"
            >
            </multiselect>
          </div>
        </div>
        <div class="row">
          <div
            v-if="
              form_update.id_type_user.id == 1 ||
              form_update.id_type_user.id == 3
            "
            class="col-md-6"
          >
            <base-input
              type="text"
              label="ID de entrenador"
              placeholder="Indica tu ID de entrenador"
              v-model="form_update.id_rne"
            >
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label>Actualizar contraseña</label>
            <input type="checkbox" class="ms-2" v-model="showPasswordFields" />
          </div>

          <div v-if="showPasswordFields" class="col-md-6">
            <base-input
              type="password"
              label="Contraseña"
              placeholder="Indica tu contraseña"
              v-model="form_update.password"
            >
            </base-input>
          </div>
          <div v-if="showPasswordFields" class="col-md-6">
            <base-input
              v-if="form_update.password"
              type="password"
              label="Repite la contraseña"
              placeholder="Confirma tu contraseña"
              v-model="form_update.password2"
            >
            </base-input>
            <base-input
              v-else
              type="password"
              label="Repite la contraseña"
              placeholder="Confirma tu contraseña"
              v-model="checkEmptyPassword"
              disabled
            >
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mt-4">
            <div class="text-end">
              <button
                type="button"
                class="btn bg-gradient-fvf"
                @click="updateElement"
              >
                <span>Actualizar mi perfil</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </card>

    <!-- Email Change Modal -->
    <div class="modal fade" id="emailChangeModal" tabindex="-1" aria-labelledby="emailChangeModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" style="border-radius: 15px; border: none;">
          <div class="modal-header border-0 pb-0">
            <h5 class="modal-title font-weight-bold" id="emailChangeModalLabel">Cambiar correo electrónico</h5>
            <button type="button" class="btn-close" @click="closeEmailChangeModal" aria-label="Close"></button>
          </div>
          <div class="modal-body px-4 pt-2">

            <!-- STEP 1: Enter new email -->
            <div v-if="emailChangeStep === 1">
              <p class="text-muted mb-3" style="font-size: 0.9rem; line-height: 1.5;">
                Indica tu nuevo correo electrónico. Enviaremos un código de verificación a ese correo para confirmar que tienes acceso.
              </p>
              <div class="mb-3">
                <label class="form-label font-weight-bold">Correo actual</label>
                <input type="text" class="form-control" :value="form_update.email" disabled style="background-color: #f4f4f4; opacity: 0.85;" />
              </div>
              <div class="mb-3">
                <label class="form-label font-weight-bold">Nuevo correo</label>
                <input type="email" class="form-control" v-model.trim="emailChangeForm.new_email" placeholder="ejemplo@correo.com" inputmode="email" />
              </div>
              <div class="text-center mt-4">
                <button type="button" class="btn bg-gradient-fvf px-4" :disabled="emailChangeLoading" @click="sendEmailChangeCode">
                  <span v-if="emailChangeLoading">Enviando...</span>
                  <span v-else>Enviar código</span>
                </button>
              </div>
            </div>

            <!-- STEP 2: Enter verification code -->
            <div v-if="emailChangeStep === 2">
              <p class="text-muted mb-3" style="font-size: 0.9rem; line-height: 1.5;">
                Hemos enviado un código de 6 dígitos a <b>{{ emailChangeForm.new_email }}</b>. Ingrésalo a continuación.
              </p>
              <div class="mb-3">
                <label class="form-label font-weight-bold">Código de verificación</label>
                <input type="text" class="form-control text-center" v-model.trim="emailChangeForm.code" placeholder="000000" maxlength="6" style="font-size: 1.5rem; letter-spacing: 8px;" />
              </div>
              <div class="text-center mt-4">
                <button type="button" class="btn bg-gradient-fvf px-4" :disabled="emailChangeLoading" @click="verifyEmailChangeCode">
                  <span v-if="emailChangeLoading">Verificando...</span>
                  <span v-else>Verificar código</span>
                </button>
              </div>
              <div class="text-center mt-2">
                <a href="javascript:;" class="text-muted" style="font-size: 0.8rem;" @click="emailChangeStep = 1">← Cambiar correo</a>
              </div>
            </div>

            <!-- STEP 3: Success -->
            <div v-if="emailChangeStep === 3">
              <div class="text-center py-3">
                <div style="font-size: 3rem;">✅</div>
                <h5 class="font-weight-bold mt-2 mb-1">¡Correo actualizado!</h5>
                <p class="text-muted" style="font-size: 0.9rem;">
                  Tu correo electrónico ha sido cambiado exitosamente a <b>{{ emailChangeForm.new_email }}</b>.
                </p>
              </div>
              <div class="text-center mt-3 mb-2">
                <button type="button" class="btn bg-gradient-fvf px-4" @click="closeEmailChangeModal">
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from "src/components/Cards/Card.vue";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import LTable from "src/components/Table.vue";
import moment from "moment";
import LoadImage from "../../../public/img/load_img.jpg";
import ObservationChat from "src/components/ObservationChat.vue";
import Cookies from "js-cookie";
import EmailValidator from "email-validator";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  components: {
    Card,
    Multiselect,
    FilePond,
    LTable,
    ObservationChat
      },
  data() {
    return {
      window_title: "Mi perfil",
      button_label: "Actualizar información",
      locale: { lang: "es", weekDays: ["L", "M", "M", "J", "V", "S", "D"] },
      countries: [],
      loaded: false,
      showPasswordFields: false,
      loadingData: true,

      id_user_logged: Cookies.get("id"),
      form_update: {
        id: 0,
        url_image: "",
        first_name: "",
        last_name: "",
        dni: "",
        phone: "",
        id_city: {
          id: "",
          name: "",
        },
        email: "",
        id_rne: "",
        id_type_user: {
          id: 0,
          name: "",
        },
        country: {
          id: "",
          name: "",
        },
        state: {
          id: "",
          name: "",
        },
      },

      TypeUserTmp: [
        { id: 1, name: "Entrenador" },
        { id: 2, name: "Jugador retirado" },
        { id: 3, name: "Entrenador y Jugador retirado" },
        { id: 0, name: "Ninguno de los anteriores" },
      ],

      CountryTmp: [],
      StateTmp: [],
      CityTmp: [],

      // Email change modal
      emailChangeStep: 1,
      emailChangeLoading: false,
      emailChangeForm: {
        new_email: "",
        code: "",
      },
      emailChangeModalInstance: null,
    };
  },
  mounted() {
    this.getElement(this.id_user_logged);
  },
  computed: {
    ...mapState({
      me: (state) => state.auth.me,
      me_rol: (state) => state.auth.me_rol,
    }),
    sortOptions() {
      return [];
    },
    sortedStateTmp() {
      return this.StateTmp.slice().sort((a, b) => a.name.localeCompare(b.name));
    },
    sortedCountryTmp() {
      return this.CountryTmp.sort((a, b) => a.name.localeCompare(b.name));
    },

    checkEmptyPassword() {
      console.log("hola");
      if (this.form_update.password == "") {
        return (this.form_update.password2 = "");
      }
    },
  },
  methods: {
    ...mapActions([
      "getData",
      "updateData",
      "changeStatusData",
      "createData",
      "updateDataAutenticated",
    ]),
    onCountryChange() {
      this.form_update.state = null;
      this.form_update.id_city = null;
      this.loadState();
    },
    onStateChange() {
      this.form_update.id_city = null;
      this.loadCity();
    },
    showObs() {
      $("#modalObs").modal("toggle");
      this.$refs.ObservationChat.loadObservations();
    },

    changeDate() {
      console.log(this.form_update.date_registration_rif);
    },

    prefixChange() {
      console.log(this.form_update.prefix);
      this.prefixTemp = [
        {
          id: 0,
          name: "V-",
        },
        {
          id: 1,
          name: "J-",
        },
        {
          id: 2,
          name: "G-",
        },
        {
          id: 3,
          name: "E-",
        },
      ];
    },

    getElement(id) {
      this.loaded = false;
      this.loadingData = true;
      let data_params = {
        url: "user/user/myprofile/",
        params: {
          active: 1,
          order_by: "id",
          order_value: "desc",
        },
      };

      this.getData(data_params)
        .then((response) => {
          this.form_update = response.data;

          // Asignar tipo de usuario desde el objeto type_user o buscarlo por id
         

          // Asignar país desde el objeto country
          if (response.data.country) {
            this.form_update.country = response.data.country;
          }

          // Asignar estado desde el objeto state
          if (response.data.state) {
            this.form_update.state = response.data.state;
          }

          // Asignar ciudad desde el objeto city
          if (response.data.city) {
            this.form_update.id_city = response.data.city;
          }

          // Asignar imagen de perfil
          if (response.data.profile_picture) {
            this.form_update.url_image = response.data.profile_picture;
          }

          this.loadCountry();

          this.loaded = true;
          this.loadingData = false;
        })
        .catch((error) => {
          this.loaded = true;
          this.loadingData = false;
          console.log(error);
        });
    },
    returnUrl() {
      this.$router.go(-1);
    },

    changeStatus(data) {
      let active = data.active === 1 ? 2 : 1;
      let title = data.active === 1 ? "Eliminar" : "Activar";
      let title2 = data.active === 1 ? "Desactivado" : "Activado";
      let text =
        data.active === 1
          ? "¿Estás seguro de eliminar este usuario?"
          : "¿Estás seguro de activar este usuario?";
      Swal.fire({
        title: title,
        text: text,
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#430098ff",
        cancelButtonColor: "#c4c5c8ff",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let form = {
            id: data.id,
            url: "user_club/change_status",
            status: active,
          };
          this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadUserClubs();
                data.active = active;
                Swal.fire({
                  title: "Usuario eliminado correctamente",
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  confirmButtonColor: "#430098ff",
                  timer: 1000,
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },

    handleFileUpdate(files) {
      if (files && files.length > 0 && files[0] && files[0].file) {
        const file = files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
          const backgroundImage = document.getElementById("backgroundImage");
          if (backgroundImage) {
            backgroundImage.style.display = "none";
          }
        };

        reader.readAsDataURL(file.file);
      } else {
        const backgroundImage = document.getElementById("backgroundImage");
        if (backgroundImage) {
          backgroundImage.src = LoadImage;
          backgroundImage.style.display = "block";
        }
      }
    },

    updateElement() {
      if (!this.form_update.first_name) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe ingresar un nombre",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else if (!this.form_update.last_name) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe ingresar un apellido",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else if (!this.form_update.dni) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe ingresar un número de cédula o pasaporte",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else if (!this.form_update.email) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe ingresar un correo electrónico",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else if (!this.form_update.phone) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe ingresar un número de teléfono",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else if (!this.form_update.country) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe seleccionar un país",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else if (!this.form_update.state) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe seleccionar un estado",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else if (!this.form_update.id_city) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe seleccionar una ciudad",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else if (this.showPasswordFields && this.form_update.password !== this.form_update.password2) {
        Swal.fire({
          title: "¡Atención!",
          text: "Las contraseñas no coinciden",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else {
        Swal.fire({
          title: "¡Atención!",
          text: "¿Estás seguro de actualizar su información?",
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonColor: "#B49B57",
          cancelButtonColor: "#9F9F9F",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Si, actualizar",
        }).then((result) => {
          let data_form;

          if (result.value) {
            data_form = new FormData();
            data_form.append("first_name", this.form_update.first_name);
            data_form.append("last_name", this.form_update.last_name);
            data_form.append("phone", this.form_update.phone);
            data_form.append("id_country", this.form_update.country.id);
            data_form.append("id_state", this.form_update.state.id);
            data_form.append("dni", this.form_update.dni);
            data_form.append("id_city", this.form_update.id_city.id);
                       
            if (
              this.form_update.password !== "" &&
              this.form_update.password !== null &&
              this.form_update.password !== undefined
            ) {
              data_form.append("password", this.form_update.password);
            }
            console.log(this.form_update);
            
            // Check if filePond exists before calling getFiles()
            const filePond = this.$refs.filePond;
            if (filePond) {
              const filePondInstance = filePond.getFiles();
              if (
                filePondInstance &&
                filePondInstance.length > 0 &&
                filePondInstance[0].file
              ) {
                console.log("[Edit] Adding new image from filePond");
                data_form.append("url_image", filePondInstance[0].file);
              }
            } else {
              console.log("[Edit] No filePond instance found (using existing image or no change)");
            }
          }

          this.deleting = true;
          let form = {
            url: "user/user/update",
            // id: this.form_update.id,
            data: data_form,
          };
          this.updateDataAutenticated(form)
            .then((response) => {
              if (response.code === 200) {
                this.deleting = false;
                Swal.fire({
                  title: "Datos actualizados correctamente",
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  timer: 1000,
                });

                const expires_in = moment().format("YYYY-MM-DD HH:mm");
                const expires_at = moment(expires_in)
                  .add(4, "hours")
                  .format("YYYY-MM-DD HH:mm");
                const expires_at_date = new Date(expires_at);



              }
              if (response.code === 403) {
                this.deleting = false;
                Swal.fire({
                  title: "Ya existe otro usuario con este teléfono",
                  icon: "warning",
                  showConfirmButton: true,
                  showLoaderOnConfirm: true,
                });
                // this.$router.push("registro");
              }
              if (response.code === 409) {
                this.deleting = false;
                Swal.fire({
                  title: "Ya existe un usuario con estos datos",
                  icon: "warning",
                  showConfirmButton: true,
                  showLoaderOnConfirm: true,
                });
                // this.$router.push("registro");
              }
              if (response.code === 410) {
                this.deleting = false;
                Swal.fire({
                  title: "Ya existe un usuario con este RNE",
                  icon: "warning",
                  sshowConfirmButton: true,
                  showLoaderOnConfirm: true,
                });
              }
            })
            .catch((error) => {
              console.log(error);
              this.deleting = false;
              alert("Ocurrió un error, intente más tarde");
            });
        });
      }
    },

    loadState() {
      const countryId =
        (this.form_update && this.form_update.country && this.form_update.country.id) ||
        (this.form_update && this.form_update.id_country) ||
        null;

      if (!countryId) {
        this.StateTmp = [];
        this.form_update.state = null;
        return;
      }

      let form = {
        url: "master/state/all",
        params: {
          id_country: countryId,
          order_value: "asc",
          order_by: "name",
          active: 1,
          lite: 1,
        },
      };

      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.StateTmp = response.data;

            const wantedStateId =
              (this.form_update && this.form_update.state && this.form_update.state.id) ||
              (this.form_update && this.form_update.id_state) ||
              null;

            if (wantedStateId) {
              const match = this.StateTmp.find(
                (s) => String(s.id) === String(wantedStateId)
              );
              if (match) {
                this.form_update.state = match;
              }
            }

             this.loadCity();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadCity() {
      const stateId =
        (this.form_update && this.form_update.state && this.form_update.state.id) ||
        (this.form_update && this.form_update.id_state) ||
        null;

      if (!stateId) {
        this.CityTmp = [];
        this.form_update.id_city = null;
        return;
      }

      let form = {
        url: "master/city/all",
        params: {
          id_state: stateId,
          order_value: "asc",
          order_by: "name",
          active: 1,
          lite: 1,
        },
      };

      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.CityTmp = response.data;

            const wantedCityId =
              (this.form_update &&
                this.form_update.id_city &&
                (this.form_update.id_city.id || this.form_update.id_city)) ||
              null;

            if (wantedCityId) {
              const match = this.CityTmp.find(
                (c) => String(c.id) === String(wantedCityId)
              );
              if (match) {
                this.form_update.id_city = match;
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadCountry() {
      let form = {
        url: "master/country/all",
        params: {
          order_value: "asc",
          order_by: "name",
          active: 1,
          lite: 1,
        },
      };
      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.CountryTmp = response.data;

            const wantedCountryId =
              (this.form_update && this.form_update.country && this.form_update.country.id) ||
              (this.form_update && this.form_update.id_country) ||
              null;

            if (wantedCountryId) {
              const match = this.CountryTmp.find(
                (c) => String(c.id) === String(wantedCountryId)
              );
              if (match) {
                this.form_update.country = match;
                this.loadState();
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    removeProfileImage() {
      this.form_update.url_image = null;
      if (this.$refs.filePond) {
        this.$refs.filePond.removeFiles();
      }
    },

    openEmailChangeModal() {
      this.emailChangeStep = 1;
      this.emailChangeForm.new_email = "";
      this.emailChangeForm.code = "";
      this.emailChangeLoading = false;

      const modalEl = document.getElementById("emailChangeModal");
      if (window.bootstrap && window.bootstrap.Modal) {
        this.emailChangeModalInstance = new window.bootstrap.Modal(modalEl);
        this.emailChangeModalInstance.show();
      } else {
        $(modalEl).modal("show");
      }
    },

    closeEmailChangeModal() {
      if (this.emailChangeModalInstance) {
        this.emailChangeModalInstance.hide();
      } else {
        const modalEl = document.getElementById("emailChangeModal");
        $(modalEl).modal("hide");
      }
      if (this.emailChangeStep === 3) {
        window.location.reload();
      }
    },

    sendEmailChangeCode() {
      if (!this.emailChangeForm.new_email) {
        Swal.fire({ title: "Correo requerido", text: "Debes indicar el nuevo correo electrónico", icon: "warning" });
        return;
      }
      if (!EmailValidator.validate(this.emailChangeForm.new_email)) {
        Swal.fire({ title: "Correo inválido", text: "Debes escribir un correo electrónico válido", icon: "warning" });
        return;
      }
      if (this.emailChangeForm.new_email.toLowerCase() === this.form_update.email.toLowerCase()) {
        Swal.fire({ title: "Mismo correo", text: "El nuevo correo debe ser diferente al actual", icon: "warning" });
        return;
      }

      this.emailChangeLoading = true;
      let form = {
        url: "user/user/send_email_change_code",
        data: { new_email: this.emailChangeForm.new_email }
      };
      this.createData(form)
        .then((response) => {
          this.emailChangeLoading = false;
          if (response.code === 200) {
            Swal.fire({ title: "Código enviado", text: "Revisa la bandeja de entrada de tu nuevo correo", icon: "success", timer: 2000, showConfirmButton: false });
            this.emailChangeStep = 2;
          } else {
            Swal.fire({ title: "Atención", text: response.alert || response.message || "No se pudo enviar el código", icon: "warning" });
          }
        })
        .catch((error) => {
          this.emailChangeLoading = false;
          console.error(error);
          Swal.fire({ title: "Error", text: error?.message || "Ocurrió un error, intente más tarde", icon: "error" });
        });
    },

    verifyEmailChangeCode() {
      if (!this.emailChangeForm.code || this.emailChangeForm.code.length < 6) {
        Swal.fire({ title: "Código requerido", text: "Debes ingresar el código de 6 dígitos", icon: "warning" });
        return;
      }

      this.emailChangeLoading = true;
      let form = {
        url: "user/user/verify_email_change_code",
        data: { new_email: this.emailChangeForm.new_email, code: this.emailChangeForm.code }
      };
      this.createData(form)
        .then((response) => {
          this.emailChangeLoading = false;
          if (response.code === 200) {
            this.confirmEmailChange();
          } else {
            Swal.fire({ title: "Código inválido", text: response.alert || response.message || "El código ingresado no es correcto o ha expirado", icon: "warning" });
          }
        })
        .catch((error) => {
          this.emailChangeLoading = false;
          console.error(error);
          Swal.fire({ title: "Error", text: "Ocurrió un error, intente más tarde", icon: "error" });
        });
    },

    confirmEmailChange() {
      this.emailChangeLoading = true;
      let form = {
        url: "user/user/confirm_email_change",
        data: { new_email: this.emailChangeForm.new_email, code: this.emailChangeForm.code }
      };
      this.createData(form)
        .then((response) => {
          this.emailChangeLoading = false;
          if (response.code === 200) {
            this.form_update.email = this.emailChangeForm.new_email;
            this.emailChangeStep = 3;
          } else {
            Swal.fire({ title: "Error", text: response.alert || response.message || "No se pudo actualizar el correo", icon: "error" });
          }
        })
        .catch((error) => {
          this.emailChangeLoading = false;
          console.error(error);
          Swal.fire({ title: "Error", text: "Ocurrió un error, intente más tarde", icon: "error" });
        });
    },
  },
};
</script>
<style>
.datepicker-container {
  width: 100%;
}

input.mx-input {
  border: none;
}

.form-control:hover {
  box-shadow: #b49b57;
  border-color: #b49b57;
}

.filepond--drop-label.filepond--drop-label label {
  text-align: center !important;
  color: black !important;
  font-size: small;
}
</style>
<style scoped>
/* Define la altura máxima y permite el desplazamiento */
.scrollable {
  max-height: 400px;
  overflow-y: auto;
}
.user-header {
  font-weight: bold;
  font-size: 15.6px;
}
.user-row {
  font-size: 15.6px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
